import { timestampDate, timestampFromDate } from '@bufbuild/protobuf/wkt';
import { Client } from '@connectrpc/connect';

import CancelToken from './cancelToken';
import { AuditlogService } from './espb/auditlog_service_pb';
import EspbServiceClientFactory from './EspbServiceClientFactory';
import { requireFieldNotEmpty } from './grpcUtils';
import { ClientType, AuditlogAnchor, AuditlogEventFilter } from './types';

export default class AuditlogAdminClient {
  private readonly espbClient: Client<typeof AuditlogService>;

  constructor(
    public readonly baseUri: string,
    public readonly authToken: string,
    public readonly clientType: ClientType,
    public readonly clientId?: string,
    public readonly clientVersion?: string,
  ) {
    const factory = new EspbServiceClientFactory({
      authTokens: {
        auditlogAdmin: authToken,
      },
      clientId,
      clientType,
      clientVersion,
      baseUri,
      syncSuperUsers: false,
    });
    this.espbClient = factory.createServiceClient(AuditlogService);
  }

  async listEvents(
    page: number,
    filter: AuditlogEventFilter,
    timeAnchor: AuditlogAnchor | undefined,
    cancelToken?: CancelToken,
  ): Promise<{
    events: string[];
    totalCount: number;
    timeAnchor: AuditlogAnchor;
  }> {
    const resp = await this.espbClient.listEvents(
      {
        page,
        timeAnchor: timeAnchor ? timestampFromDate(timeAnchor) : undefined,
        fromTime: filter.fromTime ? timestampFromDate(filter.fromTime) : undefined,
        toTime: filter.toTime ? timestampFromDate(filter.toTime) : undefined,
        eventTypes: filter.eventTypes,
        filterLoginIds: filter.loginIds,
        filterProfileIds: filter.profileIds,
        filterTargetProfileIds: filter.targetProfileIds,
        filterVaultIds: filter.vaultIds,
        filterIpPrefix: filter.ipPrefix,
        additionalFilter:
          filter.additionalFilter ?
            {
              ...filter.additionalFilter,
              filterIpPrefix: filter.additionalFilter.ipPrefix,
            }
          : undefined,
      },
      { signal: cancelToken?.signal },
    );
    const events = resp.envelopedEventJson;
    const totalCount = Number(resp.totalCount);
    const respTimeAnchor = timestampDate(requireFieldNotEmpty(resp.timeAnchor));
    return { totalCount, events, timeAnchor: respTimeAnchor };
  }
}
